import { Questionnaire } from "@medplum/fhirtypes";

import { createEntityAdapter, createSelector, createSlice } from "@reduxjs/toolkit";

import { FormsLibrarySection } from "@/fhir/enums/quilted-health";
import { findContextBySection } from "@/settings/utils/forms-library";

import { RootState } from "..";

const formsLibraryAdapter = createEntityAdapter({
  selectId: (questionnaire: Questionnaire) => questionnaire.id!,
});

const reducers = {
  loadQuestionnaires: formsLibraryAdapter.setAll,
};

export const formsLibrarySlice = createSlice({
  name: "formsLibrary",
  initialState: formsLibraryAdapter.getInitialState(),
  reducers,
});

export const { loadQuestionnaires } = formsLibrarySlice.actions;

const selectQuestionnairesEntities = (state: RootState) => state.formsLibrary.entities;

export const selectQuestionnairesList = createSelector(
  [selectQuestionnairesEntities],
  (questionnairesEntities): Questionnaire[] => Object.values(questionnairesEntities),
);

export const selectQuestionnaire = createSelector(
  [selectQuestionnairesEntities, (_, questionnaireId) => questionnaireId],
  (questionnairesEntities, questionnaireId): Questionnaire | undefined =>
    questionnairesEntities[questionnaireId],
);

export const selectIntakeFormsQuestionnaire = createSelector(
  [selectQuestionnaire],
  (questionnaire): Questionnaire | undefined => {
    if (
      !questionnaire ||
      !findContextBySection(questionnaire.useContext, FormsLibrarySection.IntakeForms)
    ) {
      return;
    }

    return questionnaire;
  },
);

export const selectIntakeFormsQuestionnairesList = createSelector(
  [selectQuestionnairesList],
  (questionnairesList) =>
    questionnairesList.filter((questionnaire) =>
      findContextBySection(questionnaire.useContext, FormsLibrarySection.IntakeForms),
    ),
);

export const selectConsentFormsQuestionnairesList = createSelector(
  [selectQuestionnairesList],
  (questionnairesList) =>
    questionnairesList.filter((questionnaire) =>
      findContextBySection(questionnaire.useContext, FormsLibrarySection.ConsentForms),
    ),
);

export const selectAssessmentsQuestionnairesList = createSelector(
  [selectQuestionnairesList],
  (questionnairesList) =>
    questionnairesList.filter((questionnaire) =>
      findContextBySection(questionnaire.useContext, FormsLibrarySection.Assessments),
    ),
);
export default formsLibrarySlice.reducer;
